import React from 'react';
import {Box, TextField, Typography} from '@material-ui/core';
import {IPostHarvestReviewFormProps} from './AddNewDataPointForm.types';

export const PostHarvestReviewForm: React.FC<IPostHarvestReviewFormProps> = ({
  data,
  onDataChange,
}) => {
  const handleChange = (field: string, value: any) => {
    onDataChange({...data, [field]: value});
  };

  return (
    <>
      <Box mb={2}>
        <Typography style={{fontSize: 14, fontWeight: 500, marginBottom: 6}}>
          Key Successes
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={2}
          variant="outlined"
          size="small"
          placeholder="What went well?"
          value={data.keySuccesses}
          onChange={(e) => handleChange('keySuccesses', e.target.value)}
          InputProps={{style: {backgroundColor: '#fff', borderRadius: 8}}}
        />
      </Box>

      <Box mb={2}>
        <Typography style={{fontSize: 14, fontWeight: 500, marginBottom: 6}}>
          Areas for Improvement
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={2}
          variant="outlined"
          size="small"
          placeholder="What could be improved?"
          value={data.areasForImprovement}
          onChange={(e) => handleChange('areasForImprovement', e.target.value)}
          InputProps={{style: {backgroundColor: '#fff', borderRadius: 8}}}
        />
      </Box>

      <Box mb={2}>
        <Typography style={{fontSize: 14, fontWeight: 500, marginBottom: 6}}>
          Recommendations for Next Season
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={2}
          variant="outlined"
          size="small"
          placeholder="Enter recommendations"
          value={data.recommendationsForNextSeason}
          onChange={(e) =>
            handleChange('recommendationsForNextSeason', e.target.value)
          }
          InputProps={{style: {backgroundColor: '#fff', borderRadius: 8}}}
        />
      </Box>

      <Box mb={2}>
        <Typography style={{fontSize: 14, fontWeight: 500, marginBottom: 6}}>
          Lessons Learned
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={2}
          variant="outlined"
          size="small"
          placeholder="Enter lessons learned"
          value={data.lessonsLearned}
          onChange={(e) => handleChange('lessonsLearned', e.target.value)}
          InputProps={{style: {backgroundColor: '#fff', borderRadius: 8}}}
        />
      </Box>

      <Box mb={2}>
        <Typography style={{fontSize: 14, fontWeight: 500, marginBottom: 6}}>
          Profitability Assessment
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          placeholder="Enter assessment"
          value={data.profitabilityAssessment}
          onChange={(e) =>
            handleChange('profitabilityAssessment', e.target.value)
          }
          InputProps={{style: {backgroundColor: '#fff', borderRadius: 8}}}
        />
      </Box>
    </>
  );
};
